import { spacesDOSettingsApi } from "src/api/spaces-do-settings";
import { slice } from "src/slices/spaces-do-settings";

// Get Portal Spaces DO Settings
const getSpacesDOSettings = () => async (dispatch) => {
  dispatch(slice.actions.spacesDOSettingsLoading());
  const response = await spacesDOSettingsApi.getSpacesDoSettings();
  dispatch(slice.actions.spacesDOSettingsReceived(response));
};

export const spacesDOSettingsThunks = {
  getSpacesDOSettings,
};
